// features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { registerUser, loginUser, changePassword } from "./AuthActions";

const initialState = {
  authLoading: false,
  userInfo: {}, // for user object
  userToken: null, // for storing the JWT
  authError: null,
  success: false, // for monitoring the registration process.
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: {
    // register user
    [registerUser.pending]: (state) => {
      state.authLoading = true;
      state.authError = null;
    },
    [registerUser.fulfilled]: (state, { payload }) => {
      state.authLoading = false;
      state.success = true; // registration successful
    },
    [registerUser.rejected]: (state, { payload }) => {
      state.authLoading = false;
      state.authError = payload;
    },
    // login user
    [loginUser.pending]: (state) => {
      state.authLoading = true;
      state.authError = null;
    },
    [loginUser.fulfilled]: (state, { payload }) => {
      state.authLoading = false;
      state.userInfo = payload.data.user;
      state.userToken = payload.data.access_token;
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.authLoading = false;
      state.authError = payload;
    },
    // login user
    [changePassword.pending]: (state) => {
      state.authLoading = true;
      state.authError = null;
    },
    [changePassword.fulfilled]: (state, { payload }) => {
      state.authLoading = false;
    },
    [changePassword.rejected]: (state, { payload }) => {
      state.authLoading = false;
      state.authError = payload;
    },
  },
});

export default authSlice.reducer;